

exports.__esModule = true;
exports["default"] = void 0;
var _squid = require("squid");
var _util = require("xo-return-to-merchant/dist/util");
require("xo-ui-components/src/modal/directive");
var _template = _interopRequireDefault(require("./template"));
var _uiRouter = require("uiRouter");
var _logger = require("xo-beaver/dist/logger");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _squid.$Component.extend('$xoSoldoutPageDirective', {
  tag: 'xo-soldout-page',
  template: _template["default"],
  auth: false,
  actions: {
    continueShoppingHandler: function continueShoppingHandler() {
      _util.$ReturnToMerchant.goTo(decodeURIComponent(_uiRouter.$state.params.soldOutUrl), true);
    }
  },
  lifecycle: {
    enter: function enter() {
      this.locale = _squid.$locale;
      angular.element('.paypalHeader').css('display', 'none');
      angular.element('#defaultCancelLink').css('display', 'none');
      _logger.$logger.info('checkout_fpti', {
        landing_page: 'sold_out',
        int_error_code: '0',
        int_error_description: 'cart item sold out'
      });
    },
    populate: function populate() {
      this.item_name = decodeURIComponent(_uiRouter.$state.params.items);
    }
  }
});
_squid.$Component;
_squid.$locale;
_util.$ReturnToMerchant;
_uiRouter.$state;
_logger.$logger;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-form-components/src/inventory-soldout/directive.js
// module id = ../node_modules/xo-form-components/src/inventory-soldout/directive.js
// module chunks = 0